<template>
	<v-menu :activator="event.el" location="end center" open-on-hover :close-on-content-click="false" transition="slide-x-transition">
		<v-card class="pa-4">
			<div class="text-center">
				<strong>{{ event.title }}</strong>
			</div>
			<div class="text-center">
				<strong> {{ timeRange }} </strong>
			</div>
			<div class="d-flex flex-column mt-4">
				<div class="d-flex text-no-wrap text-body-2">
					<div>
						<label>Duration:</label>
					</div>
					<div class="ml-2">
						{{ secondsToFormat(event.duration) }}
					</div>
				</div>
				<div class="d-flex text-no-wrap text-body-2 mt-2">
					<div>
						<label>Priority:</label>
					</div>
					<div class="ml-2">
						{{ priorityLane }}
					</div>
				</div>
				<div class="text-center pt-2">
					<label class="text-caption text-body-2 px-1">{{ event.statusLabel }}</label>
					<v-icon size="14">{{ event.statusIcon }}</v-icon>
				</div>
			</div>
		</v-card>
	</v-menu>
</template>

<script>
/* Libraries */
import moment from "moment-timezone";

/* Mixins */
import DurationFormatMixin from "@/mixins/DurationFormatMixin";

/* Enums */
import PriorityLanes from "@/enums/PriorityLanes";

export default {
	name: "CalendarEvent",

	mixins: [
		DurationFormatMixin
	],

	props: {
		event: {
			type: Object,
			require: true
		},
		timezone: {
			type: String,
			require: true
		}
	},

	computed: {
		timeRange() {
			return `${this.formatDate(this.event.start)} - ${this.formatDate(this.event.end)}`;
		},

		priorityLane() {
			return PriorityLanes.getNameByPriority(this.event.priority)
		}
	},

	methods: {
		formatDate(d) {
			return moment.tz(d, this.stationTimezone).format("h:mm:ssa").replaceAll(":00", "");
		}
	}
}
</script>